

(function($) {
  'use strict';

  let $footer_form = $('footer form')


  $footer_form.submit(function(e) {
    e.preventDefault()
    let formData = $(this).serialize();

    console.log(formData);

  })


}(jQuery));
